import { useEffect, useState } from 'react';

import { useLazyGetCupsPerDayQuery } from '@/store/api/petProfile';
import { CupsPerDayResponse } from '@/types/PetProfile';

export function useFetchCupsPerDay(petOwnerId?: number) {
  const [cupsData, setCupsData] = useState<CupsPerDayResponse[]>([]);
  const [triggerGetCupsPerDay] = useLazyGetCupsPerDayQuery();

  useEffect(() => {
    const fetchCupsData = async () => {
      const response = await triggerGetCupsPerDay({
        petOwnerId: petOwnerId,
      }).unwrap();

      const cupsPerDayData: CupsPerDayResponse[] = response.data;
      setCupsData(cupsPerDayData);
    };
    fetchCupsData();
  }, [petOwnerId, triggerGetCupsPerDay]);

  return cupsData;
}
